import { useAppDispatch,useAppSelector } from 'app/hooks';
import { AppSuiteTenant, UserGroup } from 'common/types/Entities';

import { useFetchProductEntitlements } from '../../hooks/useFetchProductEntitlements';
import { useFetchUserGroupsUsers } from '../../hooks/useFetchUserGroupsUsers';
import { useSetReportCompanyNameValue } from '../../hooks/useSetReportCompanyValue';
import { selectIsReportModalOpen,setReportModalOpen } from '../../reportPrintingModalSlice';
import { ReportCustomTableColumn } from '../../typeDefs';
import { ReportModalContent } from '../common/ReportModalContent';
import { ReportPrintingModal } from '../common/ReportPrintingModal';

type UserGroupsReportContentProps = {
    userGroups: UserGroup[];
    userLimit: string;
    userLimitDisabled: boolean;
    currentTenant: AppSuiteTenant;
}

const PRODUCT_ENTITLEMENTS_COLUMNS: ReportCustomTableColumn[] = [
    { id: 'usergroupName', label: 'Company Group', minWidth: 120, align: 'left' },
    { id: 'resourceDisplayName', label: 'Product Name', minWidth: 120, align: 'left' },
    { id: 'accessName', label: 'Access', minWidth: 120, align: 'left' },
    { id: 'licenseBillingRecord', label: 'Billing', minWidth: 120, align: 'left' },
    { id: 'startDate', label: 'Start date', minWidth: 120, align: 'left' },
    { id: 'endDate', label: 'End date', minWidth: 120, align: 'left' }
];

export const UserGroupsReportContent = ({
    userGroups,
    userLimit,
    userLimitDisabled,
    currentTenant
}: UserGroupsReportContentProps) => {
    const { name: tenantName } = currentTenant;

    const dispatch = useAppDispatch();
    const modalIsOpen = useAppSelector(selectIsReportModalOpen);

    const { companyValue } = useSetReportCompanyNameValue(userGroups);
    const {
        processing: processingProductEntitlementsFetch,
        productEntitlements
    } = useFetchProductEntitlements(userGroups, currentTenant);
    const {
        processing: processingUsersFetch,
        users
    } = useFetchUserGroupsUsers(userGroups, userLimit, userLimitDisabled);

    const handleCloseReportModal = () => {
        dispatch(setReportModalOpen(false));
    };

    return (
        <ReportPrintingModal
            title='OPIS Proof of Delivery'
            firstHeaderTitle='Company'
            firstHeaderValues={[companyValue]}
            secondHeaderTitle='Product'
            secondHeaderValue={tenantName}
            open={modalIsOpen}
            onClose={handleCloseReportModal}
            processing={processingProductEntitlementsFetch || processingUsersFetch}
        >
            <ReportModalContent
                entitlementsColumns={PRODUCT_ENTITLEMENTS_COLUMNS}
                entitlementsRows={productEntitlements}
                usersRows={users}
                processingProductEntitlementsFetch={processingProductEntitlementsFetch}
                processingUsersFetch={processingUsersFetch}
            />
        </ReportPrintingModal>
    );
};
